<mat-drawer-container class="sidebar-container">
  <mat-drawer mode="side" opened class="sidebar-drawer">
    <div class="sidebar-content">

      <!-- Navigation Items -->
      <nav class="sidebar-nav">
        @for (item of visibleNavigationItems; track item) {
          <div
            class="nav-item"
            [routerLink]="item.path"
            routerLinkActive="active">
            <div class="nav-icon-container">
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            </div>
            <span class="nav-label">{{ item.label }}</span>
          </div>
        }
      </nav>
    </div>
  </mat-drawer>

  <mat-drawer-content class="main-content">
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
